var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconManagerManaging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3532 2.01562V14.0156H1.64681V2.01562H16.3532ZM17.5021 0.609375C17.1702 0.203125 16.7872 0 16.3532 0H1.64681C1.18723 0 0.791489 0.203125 0.459574 0.609375C0.153191 0.984375 0 1.45312 0 2.01562V14.0156C0 14.5469 0.153191 15.0156 0.459574 15.4219C0.791489 15.7969 1.18723 15.9844 1.64681 15.9844H5.74468V18H12.2553V15.9844H16.3532C16.7872 15.9844 17.1574 15.7969 17.4638 15.4219C17.7957 15.0156 17.9617 14.5469 17.9617 14.0156L18 2.01562C18 1.45312 17.834 0.984375 17.5021 0.609375ZM4.85106 7H3.14894C3.06596 7 3 6.55714 3 6C3 5.44286 3.06596 5 3.14894 5H4.85106C4.93404 5 5 5.44286 5 6C5 6.55714 4.93404 7 4.85106 7ZM4.85106 11H3.14894C3.06596 11 3 10.5571 3 10C3 9.44286 3.06596 9 3.14894 9H4.85106C4.93404 9 5 9.44286 5 10C5 10.5571 4.93404 11 4.85106 11ZM6.67021 7H14.3298C14.7032 7 15 6.55714 15 6C15 5.44286 14.7032 5 14.3298 5H6.67021C6.29681 5 6 5.44286 6 6C6 6.55714 6.29681 7 6.67021 7ZM14.3298 11H6.67021C6.29681 11 6 10.5571 6 10C6 9.44286 6.29681 9 6.67021 9H14.3298C14.7032 9 15 9.44286 15 10C15 10.5571 14.7032 11 14.3298 11Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconManagerManaging);
export default __webpack_public_path__ + "static/media/icon-manager-managing.d2f67d77fba2cdab1b15ada6f37262f4.svg";
export { ForwardRef as ReactComponent };